import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M11.0001 12.4142L18.293 19.7071L19.7072 18.2929L12.4143 11L19.7072 3.70706L18.293 2.29285L11.0001 9.58574L3.70718 2.29285L2.29297 3.70706L9.58586 11L2.29297 18.2929L3.70718 19.7071L11.0001 12.4142Z" />
  </svg>
);
